import { type SyncHasMany, hasMany } from '@ember-data/model';
import DeviceConfigStaticPageModel from 'garaje/models/device-config-static-page';
import type DeviceConfigStaticPageAttributeModel from 'garaje/models/device-config-static-page-attribute';

export default class PropertyAssistanceScreenModel extends DeviceConfigStaticPageModel {
  @hasMany('device-config-static-page-attribute')
  declare deviceConfigStaticPageAttributes: SyncHasMany<DeviceConfigStaticPageAttributeModel>;
}
